/* @ngInject */
function accountManagementService (ConnectorWebService, CONSTANTS, Utils) {
  const service = {
    getStorageUsage
  }

  return service

  function getStorageUsage (customerCompanyId, options = {}) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_COMPANIES_STORAGE_TRACKING, [customerCompanyId])

    if (options.refreshCache) {
      url = Utils.fnAddQueryToUrl(url, { refreshCache: options.refreshCache })
    }

    return ConnectorWebService.get(url)
  }
}

export { accountManagementService }
